import * as React from "react"
import {useEffect, useState} from "react";

import MemberNameAndAvatar from "./MemberNameAndAvatar";
import MemberForm from "./MemberForm";
import MemberFiles from "./MemberFiles";
import {useAppDispatch, useAppSelector} from "../../redux/storeHooks";
import Loader from "../ui/Loader";
import {fetchFiles} from "./memberFilesSlice";
import MemberContext from "./MemberContext";
import {useNavigate} from "react-router-dom";

const MemberPage = () => {

  const {filesStatus} = useAppSelector((store) => store.memberFilesState);
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const hasFileUpload = document.pageInfo ? !!document.pageInfo.hasFileUpload : false;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchFiles({navigate}))
  }, [dispatch, navigate]);

  if (filesStatus === "loading") {
    return (
      <div className="min-h-500 relative">
        <Loader/>
      </div>
    )
  }

  return (
    <MemberContext.Provider value={{uploadedFiles, setUploadedFiles}}>
      <div className="min-h-500">
        <MemberNameAndAvatar/>
        {hasFileUpload && <MemberFiles/>}
        {hasFileUpload && <MemberForm/>}
      </div>
    </MemberContext.Provider>
  )
}

export default MemberPage
